import LineGradient from "../components/LineGradient";
import { motion } from "framer-motion";
import image1 from '../assets/sweet.PNG'
import img111 from '../assets/111.png'
import image2 from '../assets/am.PNG'
import image4 from '../assets/4.PNG'
import img5 from '../assets/makeup.PNG'
import Needy from '../assets/needy.PNG'
import { Link } from "react-router-dom";
import light from '../assets/light.PNG'

const ProjectHome = () => {

  const handleButtonClick = () => {

    window.scrollTo(0, 0);
  };


  return (
    <section id="projects" className="pt-32 pb-16">
      {/* HEADING */}
      <motion.div
        className="md:w-1/3 text-center md:text-left"
        initial="hidden"
        whileInView="visible"
        viewport={{ once: true, amount: 0.5 }}
        transition={{ duration: 0.5 }}
        variants={{
          hidden: { opacity: 0, x: -50 },
          visible: { opacity: 1, x: 0 },
        }}
      >
        <p className="font-playfair font-semibold text-4xl mb-5 text-cyan-400">
          MY PROJECTS
        </p>
        <LineGradient width="mx-auto w-2/5" />
        <p className="mt-10">
          Check out some of my projects right here
        </p>
      </motion.div>

      {/* Projects */}
      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-5">
        <motion.div
          className="mx-auto relative border  opacity-70 border-cyan-400 max-w-[400px] h-[350px] flex flex-col justify-end  mt-12
            before:absolute before:top-[-120px] before:-ml-[110px] before:left-1/2 "
          initial="hidden"
          whileInView="visible"
          viewport={{ once: true, amount: 0.5 }}
          transition={{ duration: 0.6 }}
          variants={{
            hidden: { opacity: 0, scale: 0.8 },
            visible: { opacity: 1, scale: 1 },
          }}
        >
          <img src={img111} alt="" />
          <p className="font-playfair text-center text-2xl mt-3 mb-3 ">  Courier jX </p>
          <p className="text-center text-xl mb-5">
            Courier-Parcel-Management
          </p>
          <div className="grid grid-cols-2">
            <a
              className="hover:opacity-50 text-deep-blue font-bold transition text-center duration-500  bg-cyan-400 p-3"
              href="https://courier-service-beta.vercel.app/"
              target="_blank"
              rel="noreferrer"
            >
              <button className=''>Live Site</button>
            </a>
            <a
              className="hover:opacity-50 text-deep-blue font-bold text-center transition duration-500 bg-cyan-500 p-3"
              href="https://github.com/Anjum109/courier-parcel-management"
              target="_blank"
              rel="noreferrer"
            >
              <button>Github Link</button>
            </a>
            {/* <a
              className="hover:opacity-50 text-deep-blue font-bold text-center transition duration-500 bg-cyan-600 p-3"
              href="https://github.com/Anjum109/NeedyShop/tree/main/server%20site"
              target="_blank"
              rel="noreferrer"
            >
              <button>Server Site</button>
            </a> */}
          </div>

        </motion.div>
        <motion.div
          className="mx-auto relative border  opacity-70 border-cyan-400 max-w-[400px] h-[350px] flex flex-col justify-end  mt-12
            before:absolute before:top-[-120px] before:-ml-[110px] before:left-1/2 "
          initial="hidden"
          whileInView="visible"
          viewport={{ once: true, amount: 0.5 }}
          transition={{ duration: 0.6 }}
          variants={{
            hidden: { opacity: 0, scale: 0.8 },
            visible: { opacity: 1, scale: 1 },
          }}
        >
          <img src={img5} alt="" />
          <p className="font-playfair text-center text-2xl mt-3 mb-3 ">  MakeUp Mania (Ongoing) </p>
          <p className="text-center text-xl mb-5">
            Makeup & Spa Salon
          </p>
          <div className="grid grid-cols-2">
            <a
              className="hover:opacity-50 text-deep-blue font-bold transition text-center duration-500  bg-cyan-400 p-3"
              href="https://main--makeup-mania340.netlify.app/"
              target="_blank"
              rel="noreferrer"
            >
              <button className=''>Live Site</button>
            </a>
            <a
              className="hover:opacity-50 text-deep-blue font-bold text-center transition duration-500 bg-cyan-500 p-3"
              href="https://github.com/Anjum109/makeup-mania"
              target="_blank"
              rel="noreferrer"
            >
              <button>Client Side</button>
            </a>
            {/* <a
              className="hover:opacity-50 text-deep-blue font-bold text-center transition duration-500 bg-cyan-600 p-3"
              href="https://github.com/Anjum109/NeedyShop/tree/main/server%20site"
              target="_blank"
              rel="noreferrer"
            >
              <button>Server Site</button>
            </a> */}
          </div>

        </motion.div>
        <motion.div
          className="mx-auto relative border  opacity-70 border-cyan-400 max-w-[400px] h-[350px] flex flex-col justify-end  mt-12
            before:absolute before:top-[-120px] before:-ml-[110px] before:left-1/2 "
          initial="hidden"
          whileInView="visible"
          viewport={{ once: true, amount: 0.5 }}
          transition={{ duration: 0.6 }}
          variants={{
            hidden: { opacity: 0, scale: 0.8 },
            visible: { opacity: 1, scale: 1 },
          }}
        >
          <img src={Needy} alt="" />
          <p className="font-playfair text-center text-2xl mt-3 mb-3 ">  Needy Shop (Ongoing) </p>
          <p className="text-center text-xl mb-5">
            Groceries (Frontend)
          </p>
          <div className="grid grid-cols-3">
            <a
              className="hover:opacity-50 text-deep-blue font-bold transition text-center duration-500  bg-cyan-400 p-3"
              href="https://needyshop-4a73b.web.app/"
              target="_blank"
              rel="noreferrer"
            >
              <button className=''>Live Site</button>
            </a>
            <a
              className="hover:opacity-50 text-deep-blue font-bold text-center transition duration-500 bg-cyan-500 p-3"
              href="https://github.com/Anjum109/NeedyShopClientSite"
              target="_blank"
              rel="noreferrer"
            >
              <button>Client Side</button>
            </a>
            <a
              className="hover:opacity-50 text-deep-blue font-bold text-center transition duration-500 bg-cyan-600 p-3"
              href="https://github.com/Anjum109/NeedyShop/tree/main/server%20site"
              target="_blank"
              rel="noreferrer"
            >
              <button>Server Site</button>
            </a>
          </div>

        </motion.div>

        <motion.div
          className="mx-auto relative border  opacity-70 border-cyan-400 max-w-[400px] h-[350px] flex flex-col justify-end  mt-12
            before:absolute before:top-[-120px] before:-ml-[110px] before:left-1/2 "
          initial="hidden"
          whileInView="visible"
          viewport={{ once: true, amount: 0.5 }}
          transition={{ duration: 0.6 }}
          variants={{
            hidden: { opacity: 0, scale: 0.8 },
            visible: { opacity: 1, scale: 1 },
          }}
        >
          <img src={light} alt="" />
          <p className="font-playfair text-center text-2xl mt-3 mb-3 ">Light Attic</p>
          <p className="text-center text-xl mb-5">
            Pet adoption Website (Full Stack)
          </p>
          <div className="grid grid-cols-3">
            <a
              className="hover:opacity-50 text-deep-blue font-bold transition text-center duration-500  bg-cyan-400 p-3"
              href="https://light-attic.web.app/"
              target="_blank"
              rel="noreferrer"
            >
              <button className=''>Live Site</button>
            </a>
            <a
              className="hover:opacity-50 text-deep-blue font-bold text-center transition duration-500 bg-cyan-500 p-3"
              href="https://github.com/Anjum109/light-attic"
              target="_blank"
              rel="noreferrer"
            >
              <button>Client Side</button>
            </a>
            <a
              className="hover:opacity-50 text-deep-blue font-bold text-center transition duration-500 bg-cyan-600 p-3"
              href="https://github.com/Anjum109/light-attic-server"
              target="_blank"
              rel="noreferrer"
            >
              <button>Server Site</button>
            </a>
          </div>

        </motion.div>
        <motion.div
          className="mx-auto relative border  opacity-70 border-cyan-400 max-w-[400px] h-[350px] flex flex-col justify-end  mt-12
            before:absolute before:top-[-120px] before:-ml-[110px] before:left-1/2 "
          initial="hidden"
          whileInView="visible"
          viewport={{ once: true, amount: 0.5 }}
          transition={{ duration: 0.6 }}
          variants={{
            hidden: { opacity: 0, scale: 0.8 },
            visible: { opacity: 1, scale: 1 },
          }}
        >
          <img src={image1} alt="" />
          <p className="font-playfair text-center text-2xl mt-3 mb-3 ">SWEET REPEATS</p>
          <p className="text-center text-xl mb-5">
            Product Resale Website (MERN Stack)
          </p>
          <div className="grid grid-cols-3">
            <a
              className="hover:opacity-50 text-deep-blue font-bold transition text-center duration-500  bg-cyan-400 p-3"
              href="https://sweet-repeats.web.app/"
              target="_blank"
              rel="noreferrer"
            >
              <button className=''>Live Site</button>
            </a>
            <a
              className="hover:opacity-50 text-deep-blue font-bold text-center transition duration-500 bg-cyan-500 p-3"
              href="https://github.com/Anjum109/Sweet-Repeats-ClientSite"
              target="_blank"
              rel="noreferrer"
            >
              <button>Client Side</button>
            </a>
            <a
              className="hover:opacity-50 text-deep-blue font-bold text-center transition duration-500 bg-cyan-600 p-3"
              href="https://github.com/Anjum109/Sweet-Repeats-ServerSite"
              target="_blank"
              rel="noreferrer"
            >
              <button>Server Site</button>
            </a>
          </div>

        </motion.div>

        <motion.div
          className="mx-auto relative border border-cyan-400 max-w-[400px] h-[350px] flex flex-col justify-end mt-12
            before:absolute before:top-[-120px] before:-ml-[110px] before:left-1/2 "
          initial="hidden"
          whileInView="visible"
          viewport={{ once: true, amount: 0.5 }}
          transition={{ delay: 0.2, duration: 0.6 }}
          variants={{
            hidden: { opacity: 0, scale: 0.8 },
            visible: { opacity: 1, scale: 1 },
          }}
        >
          <img className="w-full" src={image2} alt="" />
          <p className="font-playfair text-center text-2xl  mt-3 mb-3">AL Dental Solution</p>
          <p className="text-center text-xl mb-5">
            Service Review Website (Full Stack)
          </p>
          <div>
            <div className="grid grid-cols-3">
              <a
                className="hover:opacity-50 transition text-deep-blue font-bold text-center duration-500  bg-cyan-400 p-3"
                href="https://am-dental-solution.web.app/"
                target="_blank"
                rel="noreferrer"
              >
                <button className=''>Live Site</button>
              </a>
              <a
                className="hover:opacity-50 text-center text-deep-blue font-bold transition duration-500 bg-cyan-500 p-3"
                href="https://github.com/Anjum109/Al-Dental-Solution-ClientSite"
                target="_blank"
                rel="noreferrer"
              >
                <button>Client Side</button>
              </a>
              <a
                className="hover:opacity-50 text-center transition text-deep-blue font-bold duration-500 bg-cyan-600 p-3"
                href="https://github.com/Anjum109/Al-Dental-Solution-ServerSite"
                target="_blank"
                rel="noreferrer"
              >
                <button>Server Site</button>
              </a>
            </div>

          </div>
        </motion.div>






      </div>
      <div className=" flex items-center justify-center mt-5">
        <button onClick={handleButtonClick} className="bg-cyan-900 text-white p-5 font-bold text-2xl mt-5 hover:bg-cyan-300 hover:text-cyan-900"><Link to='/allprojects'>See all Projects</Link></button>
      </div>
    </section>
  );
};

export default ProjectHome;
